import PlaylistFileConnection from '@/models/playlistFileConnection.ts'

export default interface Playlist {
  id: string
  files: Array<PlaylistFileConnection>
  pages: Array<PlaylistDoublePage>
  page_width: number
  page_height: number
}

export enum PlaylistDoublePageRole {
  PAGE = 'p',
  COVER = 'c',
}

export interface PlaylistDoublePage {
  id: string
  layout_id: string | null
  role: PlaylistDoublePageRole
  order: number
  width: number
  height: number
  spine_width: number
}
